// extracted by mini-css-extract-plugin
module.exports = {"modal":"modal-module--modal--fPlIQ","back":"modal-module--back--2cIbG","content":"modal-module--content--1QbTL","close":"modal-module--close--tBfnq"};